module.exports = __webpack_public_path__ + "assets/places_blue.1e3d46b8.svg";